import React from 'react';

import styles from './styles.module.scss';

const Skeleton: React.FunctionComponent = () => {
  return (
    <React.Fragment>
      <span data-nosnippet className="visuallyHidden">
        Loading copyright information
      </span>
      <div className={styles.skeleton} aria-hidden="true">
        <p>
          <small className={styles.copyright}></small>
        </p>
      </div>
    </React.Fragment>
  );
};

export default Skeleton;
